import axios from "axios";

import CreateDataRetrievalBegunAction from "./CreateDataRetrievalBegunAction";
import CreateDataRetrievalEndedAction from "./CreateDataRetrievalEndedAction";
import CreateGetEmergencyContactDetailsAction from "./CreateGetEmergencyContactDetailsAction";


export default function (id, applicationId) {
    return (dispatch) => {
        dispatch(CreateDataRetrievalBegunAction());

        axios({
            method: "DELETE",
            url: "api/EmergencyContact?id=" + id,
            withCredentials: true
        })
        .then((response) => {
            dispatch(CreateGetEmergencyContactDetailsAction(applicationId));
        })
        .catch((error) => {
            dispatch(CreateDataRetrievalEndedAction());
        });
    };
}